import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAccountsContext } from 'hooks/context/useAccountsContext'

export const LoginFooter = () => {
  const { t } = useTranslation()
  const { shouldShowUKInfoBanner } = useAccountsContext()

  return (
    <>
      {shouldShowUKInfoBanner && (
        <p className="text-body-regular-small text-foreground-faint text-center mt-auto pb-3">
          {t('ukApprovalStamp')}
        </p>
      )}
      <p className="text-body-regular-small text-foreground-faint text-center mt-auto pb-4">
        {`${t('recaptcha.protected')}`}
        <br />© 2017 - {new Date().getFullYear()} BVNK. {`${t('allRightsReserved')}`}
      </p>
    </>
  )
}
